<template>
    <Layout no-header :content-class="'login-page'">
        <div class="login-page__inner">
            <Logo class="login-page__logo" width="210" height="35" />
            <PasswordResetForm />
        </div>
    </Layout>
</template>

<script>
import Logo from '@speechki-frontend/shared/ui/layout/Logo';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import PasswordResetForm from '../../components/PasswordResetForm/PasswordResetForm.vue';

export default {
    name: 'Login',
    components: {
        Logo,
        Layout,
        PasswordResetForm
    }
};
</script>
